export { ProductColor } from './product-color.component';
